import React, { useContext, useEffect, useState } from 'react';
import './EducationalDirection.module.scss';
import {
    faBackpack,
    faChalkboardUser,
    faFamily,
    faSchool,
    faSparkles,
    faQuestion,
} from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tippy';

import { QuizContext } from 'screens/Quiz/Quiz';
import ProgressBar from '../../ProgressBar/ProgressBar';
import DirectionButton from './components/DirectionButton/DirectionButton';
import SkeletonCard from '../components/SkeletonCard/SkeletonCard';
import Content from '../components/Content/Content';

const buttons = [
    {
        image: '/images/test/education-directions/PO.jpg',
        icon: faFamily,
        buttonText: 'PO',
        text: 'Basisonderwijs',
        answerLabel: 'po',
        description:
            'Leraren basisonderwijs zijn echte sociale dieren. Je wilt ‘je’ kinderen helpen in hun ontwikkeling en bent een spin in het web. Op een basisschool is iedere dag anders. Je werkt met kinderen in de leeftijd van vier tot en met ongeveer twaalf jaar.',
    },
    {
        image: '/images/test/education-directions/VO.jpg',
        icon: faBackpack,
        buttonText: 'VO',
        text: 'Voortgezet onderwijs',
        answerLabel: 'vo',
        description:
            'Heb jij een passie voor jongeren en ook voor een speciaal vak? Of wil je gewoon graag aan de slag met jongeren? Als docent kun je pubers coachen, begeleiden, kennis en vaardigheden bijbrengen en op een positieve manier vertrouwen voor de toekomst meegeven. Met een 2e graads bevoegdheid mag je lesgeven in de onderbouw havo en vwo en onderbouw en bovenbouw van het vmbo.',
    },
    {
        image: '/images/test/education-directions/MBO.jpg',
        icon: faChalkboardUser,
        buttonText: 'MBO',
        text: 'Middelbaar beroepsonderwijs',
        answerLabel: 'mbo',
        description:
            'Als leraar op het mbo begeleid je jongeren en jongvolwassenen op hun weg naar de arbeidsmarkt. Je leidt de vakmensen van de toekomst op. Het mbo biedt verschillende functies zoals docent, maar ook bijvoorbeeld onderwijsassistent, instructeur, gastdocent, praktijkopleider of intern begeleider. ',
    },
    {
        image: '/images/test/education-directions/HBO.jpg',
        icon: faSchool,
        buttonText: 'HBO',
        text: 'Hoger beroepsonderwijs',
        answerLabel: 'hbo',
        description:
            'Wil je lesgeven op het hbo? Dan is in principe een afgeronde bachelor en master in je vakgebied vereist. Heb je eenmaal een aanstelling, dan kun je het BKO-traject (Basis Kwalificatie Onderwijs) volgen. Vaak is dit verplicht om een vaste aanstelling te krijgen.',
    },
    {
        image: '/images/test/education-directions/SO.jpg',
        icon: faSparkles,
        buttonText: 'SO',
        text: 'Speciaal onderwijs',
        answerLabel: 'so',
        description:
            'Werken op het speciaal onderwijs is, het woord zegt het al, heel speciaal. Kinderen die zijn aangewezen op het speciaal onderwijs hebben meer aandacht en zorg nodig dan op het regulier onderwijs. Door jouw begeleiding kunnen deze kinderen stappen zetten en hebben jou daar echt bij nodig.',
    },
    {
        image: '/images/test/education-directions/unkown.jpg',
        icon: faQuestion,
        buttonText: 'Weet ik nog niet',
        text: 'Weet ik nog niet',
        answerLabel: 'Weet ik nog niet',
        description:
            'Weet je nog niet welke richting bij jou past, kies dan voor deze optie. Wanneer we in gesprek gaan, is het voor ons alvast goed om te weten dat jij nog geen richting voor ogen hebt.',
    },
];

export default function EducationalDirection() {
    const [activeButton, setActiveButton] = useState(null);
    const { setQuestionIndex, setAnswers, answers } = useContext(QuizContext);

    function toNextScreen() {
        setQuestionIndex((prev) => prev + 1);
        setAnswers({
            ...answers,
            question1: buttons[activeButton].answerLabel,
        });
    }

    return (
        <div styleName="educational-direction">
            <div styleName="title">
                <div styleName="text">
                    <p>
                        Benieuwd naar jouw mogelijkheden in het onderwijs?
                        <br /> De volgende vijf vragen helpen je verder!
                    </p>
                    <h2>In welke richting wil je het onderwijs in?</h2>
                </div>
                <ProgressBar />
            </div>
            <div styleName="question">
                <div styleName="buttons">
                    {buttons.map((button, index) => (
                        <DirectionButton
                            onClick={() => {
                                setActiveButton(index);
                            }}
                            active={activeButton === index}
                            key={index}
                            icon={button?.icon}
                            text={button?.buttonText}
                        />
                    ))}
                </div>
            </div>
            <div styleName="bottom">
                <Tooltip
                    // theme="light"s
                    disabled={activeButton !== null}
                    style={{ width: 'fit-content' }}
                    title="Je hebt nog geen antwoord ingevuld"
                >
                    <Button
                        color="blue"
                        disabled={activeButton === null}
                        icon={faArrowRight}
                        onClick={toNextScreen}
                    >
                        Volgende vraag
                    </Button>
                </Tooltip>
            </div>
            <div styleName="info">
                {activeButton !== null ? (
                    <Content
                        showButton={
                            buttons[activeButton]?.text !== 'Weet ik nog niet'
                        }
                        content={buttons[activeButton]}
                    />
                ) : (
                    <SkeletonCard />
                )}
            </div>
        </div>
    );
}
